import {
    MODAL_CLOSE,
    MODAL_LOADING_START,
    MODAL_LOADING_STOP,
    MODAL_OPEN,
} from 'store/actions/types';

const initialState = {
    actions: {},
    isLoading: false,
    category: null,
    content: {},
    modal: true,
    open: false,
    title: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case MODAL_LOADING_START:
            return Object.assign({}, state, {
                isLoading: true,
            });
        case MODAL_LOADING_STOP:
            return Object.assign({}, state, {
                isLoading: true,
            });
        case MODAL_OPEN:
            return Object.assign({}, state, {
                actions: action.actions,
                category: action.category,
                content: action.content,
                modal: action.modal ? action.modal : initialState.modal,
                open: true,
                title: action.title,
            });
        case MODAL_CLOSE:
            return initialState;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/store/reducers/modalReducer.js